import { API_V1, API_V2 } from '@front-app/services/api';
import { FileContentItem, FileContentResponse } from '@front-app/services/GroupsApi/DiscussionModel';
import { parseFileContentResponse } from '@front-app/services/parse';

export interface UploadFileRequest {
	groupId: string;
	messageId?: string;
	file: File;
	fileName: string;
	category: string[];
	description: string;
	notify: boolean;
}

export interface UpdateFileMetadataRequest {
	name: string;
	description: string;
	categories: string[];
}

type UploadHandler = (e: ProgressEvent) => void;

export const downloadGroupFile = async (groupId: string, fileId: string): Promise<Blob> => {
	const resp = await API_V2.get(`/group/${groupId}/file/${fileId}/download`, {
		timeout: 0,
		responseType: 'blob',
		headers: {
			Accept: '*/*',
		},
	});
	return resp.data;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const uploadFile = async (request: UploadFileRequest, onUploadProgress: UploadHandler = () => {}): Promise<void> => {
	await API_V1.post('/file/upload', formDataFromRequest(request), {
		timeout: 0,
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		onUploadProgress,
	});
};

export function editFileMetadata(
	groupId: string,
	fileId: string,
	metadata: UpdateFileMetadataRequest,
): Promise<FileContentItem> {
	return API_V2.put(`group/${groupId}/file/${fileId}`, metadata)
		.then(({ data }) => data as FileContentResponse)
		.then(parseFileContentResponse);
}

export const deleteFile = async (groupId: string, fileId: string): Promise<void> => {
	await API_V2.delete(`/group/${groupId}/file/${fileId}`);
};

/**
 * @deprecated
 */
export const downloadFile = async (contentSource: string): Promise<Blob> => {
	const resp = await API_V1.get(`/file?${contentSource}`, {
		timeout: 0,
		responseType: 'blob',
		headers: {
			Accept: '*/*',
		},
	});
	return resp.data;
};

function formDataFromRequest(request: UploadFileRequest): FormData {
	const innerRequest = new FormData();
	innerRequest.append('groupId', request.groupId);
	if (request.messageId) {
		innerRequest.append('messageId', request.messageId ?? '');
	}
	innerRequest.append('file', request.file);
	innerRequest.append('fileName', request.fileName);
	innerRequest.append('category', request.category.join(','));
	innerRequest.append('fileInfo', request.description);
	innerRequest.append('notify', JSON.stringify(request.notify));
	return innerRequest;
}
